<template>
  <div class="mx-auto">
    <v-card flat class="pa-2">
      <v-container class="pa-5">
        <base-form-generator v-if="['kp'].includes(jenis)" :schema="schema.dasar" v-model="form" />
        <v-spacer />
        <div class="my-3">
          <h4>{{ jenis === 'kp_pa' ? 'Fasilitator' : 'Instruktur' }} Pendampingan</h4>
          <v-alert class="my-2" color="blue" text>
            <v-row>
              <v-col class="grow my-auto">
                <div class="black--text">
                  Silakan pilih {{ jenis === 'kp_pa' ? 'Fasilitator' : 'Instruktur' }} yang ditugaskan pada Kelompok
                  yang akan ditambahkan
                </div>
              </v-col>
              <v-col class="shrink">
                <v-btn :disabled="jenis === 'pendampingan'" class="success" depressed @click="onPilihInstruktur">
                  <v-icon left>mdi-hospital-building</v-icon>
                  Pilih {{ jenis === 'kp_pa' ? 'Fasilitator' : 'Instruktur' }}
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
          <template v-if="Object.keys(instruktur).length">
            <v-row class="my-3">
              <v-col cols="12" md="6" sm="12">
                <v-list-item>
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <div class="blue--text">
                      {{
                        $getDeepObj(instruktur, 'akun_instruktur.data.nama') ||
                          $getDeepObj(instruktur, 'nama') ||
                          $getDeepObj(instruktur, 'ptk.data.nama') ||
                          ''
                      }}
                    </div>
                    <div class="black--text">
                      {{
                        $getDeepObj(instruktur, 'akun_instruktur.data.email') ||
                          $getDeepObj(instruktur, 'email') ||
                          $getDeepObj(instruktur, 'ptk.data.email') ||
                          ''
                      }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col v-if="false" cols="12" md="6" sm="12">
                <div class="label--text">Penugasan Sebagai {{ jenis === 'kp_pa' ? 'Fasilitator' : 'Instruktur' }}</div>
              </v-col>
            </v-row>
          </template>
        </div>
        <template v-if="['kp'].includes(jenis)">
          <v-row v-for="(tautan, index) in tatutans" :key="index">
            <v-col cols="12" sm="12" md="6" class="py-0" v-for="(link, l) in schema.url" :key="l">
              <span class="px-0 body-2 grey--text" v-html="link.label"></span>
              <v-text-field v-model="tatutans[index][link.name]" v-bind="link"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" class="py-0">
              <div class="text-md-right">
                <v-btn color="red" depressed dark @click="onDeleteTautan(index)">
                  <v-icon left>mdi-close</v-icon>Hapus Link
                </v-btn>
                <v-btn
                  v-if="tatutans.length === index + 1"
                  class="mx-md-1"
                  color="primary"
                  depressed
                  @click="onAddTautan"
                >
                  <v-icon left>mdi-plus</v-icon>Tambah Link
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-spacer />
          <v-row>
            <template v-for="(file, idFile) in schema.file">
              <v-col cols="12" md="6" sm="12" :key="idFile">
                <div v-if="!berkases[file.id]">
                  <span class="grey--text">{{ file.label }}</span>
                  <v-file-input
                    v-model="form[file.name]"
                    :accept="['image/*', '.pdf']"
                    outlined
                    dense
                    prepend-icon=""
                    @click:append="handleClickAppend(idFile)"
                    :ref="`vFileInput_${idFile}`"
                    append-icon="mdi-paperclip"
                    :placeholder="`Unggah ${file.label || ''}`"
                    :hint="`Jenis file unggahan JPG/JPEG/PNG/GIF/PDF (${min} KB - ${roundDecimal(max / 1000)} MB).`"
                    :rules="[
                      (value) =>
                        !value ||
                        (value && value.size > roundDecimal(min * 1000)) ||
                        'Berkas yang Anda upload kurang dari ketentuan minimum!',
                      (value) =>
                        !value ||
                        (value && value.size < roundDecimal(max * 1000)) ||
                        'Berkas yang Anda upload melebihi kapasitas maksimum!',
                    ]"
                    persistent-hint
                  />
                </div>
                <div v-else>
                  <span class="grey--text">{{ file.label }} *</span>
                  <div>
                    <v-btn color="blue-grey" class="white--text mr-2" @click="toLink(file.id)" target="_blank">
                      Lihat Berkas
                      <v-icon right dark>
                        mdi-link
                      </v-icon>
                    </v-btn>
                    <v-btn color="orange" class="white--text" @click="onChangeBerkas(file)">
                      Ganti Berkas
                      <v-icon right dark>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </template>
          </v-row>
        </template>
      </v-container>
    </v-card>
    <base-list-popup
      ref="popup"
      :title="`Daftar ${jenis === 'kp_pa' ? 'Fasilitator' : 'Instruktur'}`"
      :api="`${jenis === 'kp_pa' ? 'diklatPa' : 'diklatDkp'}/getInstruktur`"
      :options="{ gelombang: this.gelombang, mGelombang: this.masters['gelombang-profil-pa'] || [] }"
    />
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import BaseListPopup from '@components/base/BaseListPopup';
import { roundDecimal } from '@utils/format';

export default {
  props: {
    initValue: {
      type: Object,
      default: () => null,
    },
    nama: {
      type: String,
      default: '',
    },
    id: {
      type: [String, Number],
      default: '1',
    },
    jenis: {
      type: String,
      default: 'kp',
    },
    gelombang: {
      type: [Number, String],
      default: 1,
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },
  components: { BaseListPopup, BaseFormGenerator },
  data() {
    return {
      form: {},
      instruktur: {},
      max: 1500,
      min: 20,
      tatutans: [],
    };
  },
  computed: {
    schema() {
      return {
        dasar: [
          {
            type: 'VTextField',
            name: 'pendampingan_ke',
            label: 'Nama Jadwal',
            labelColor: 'secondary',
            hint: 'wajib diisi',
            required: true,
            grid: { cols: 12, md: 6, sm: 12 },
            outlined: true,
            disabled: true,
            singleLine: true,
            dense: true,
          },
          {
            type: 'VDatePicker',
            name: 'tgl_pendampingan',
            label: 'Tanggal Pelaksanaan',
            labelColor: 'secondary',
            hint: 'wajib dipilih',
            required: true,
            grid: { cols: 12, md: 6, sm: 12 },
            outlined: true,
            singleLine: true,
            dense: true,
            disabled: this.jenis === 'pendampingan',
          },
        ],
        url: [
          {
            type: 'VTextField',
            name: 'nama',
            label: 'Nama Pertemuan Daring',
            labelColor: 'secondary',
            hint: '',
            required: false,
            grid: { cols: 12, md: 6, sm: 12 },
            outlined: true,
            singleLine: true,
            dense: true,
          },
          {
            type: 'VTextField',
            name: 'url_meeting',
            label: 'Link Pertemuan Daring',
            labelColor: 'secondary',
            hint: '',
            required: false,
            grid: { cols: 12, md: 6, sm: 12 },
            outlined: true,
            dense: true,
            singleLine: true,
            prependInnerIcon: 'mdi-video',
          },
          {
            type: 'VTextField',
            name: 'url_recording',
            label: 'Link Rekaman Pertemuan Daring',
            labelColor: 'secondary',
            hint: '',
            required: false,
            grid: { cols: 12, md: 6, sm: 12 },
            outlined: true,
            dense: true,
            singleLine: true,
            prependInnerIcon: 'mdi-video',
          },
        ],
        file: [
          {
            id: 1,
            name: 'file_peserta',
            label: 'Laporan Presensi',
          },
          {
            id: 99,
            name: 'file_lain',
            label: 'Laporan Pendampingan Komite Pembelajaran',
          },
        ],
      };
    },

    berkases() {
      return this.$arrToObj(
        this.$getDeepObj(this, `initValue.psp_${this.jenis}_berkases.data`) || [],
        `k_${this.jenis}_berkas_psp`
      );
    },
  },
  methods: {
    initForm(value) {
      if (!value) return;

      if (['kp'].includes(this.jenis)) {
        const formulir = [...(this.schema.dasar || [])];
        const nama = `Pendampingan Ke ${this.id}`;
        for (const item of formulir) {
          if (item.name === 'pendampingan_ke') {
            this.$set(this.form, item.name, this.jenis === 'kp_pa' ? this.nama : nama);
          } else {
            this.$set(this.form, item.name, this.$getDeepObj(value, item.name) || '');
          }
        }

        this.tatutans = [];
        const urlMeet = (value && value.data_meeting) || [];
        urlMeet.forEach((item) => {
          this.tatutans.push({
            nama: this.$getDeepObj(item, 'nama') || '',
            url_meeting: this.$getDeepObj(item, 'url_meeting') || '',
            url_recording: this.$getDeepObj(item, 'url_recording') || '',
          });
        });

        if (this.tatutans.length === 0) this.onAddTautan();
      }

      this.instruktur =
        this.$getDeepObj(value, `${this.jenis === 'kp_pa' ? 'psp_profil_pa' : 'akun_instruktur'}.data`) || {};
    },

    validate() {
      let status = true;
      if (!Object.keys(this.instruktur).length) {
        this.$error('Harap pilih instruktur pendampingan');
        status = false;
      }
      return this.jenis !== 'pendampingan' ? status : true;
    },

    reset() {
      this.$set(this, 'form', {});
      this.$set(this.form, 'pendampingan_ke', this.nama || 'Pendampingan Ke ' + this.id);
      this.$set(this, 'instruktur', {});
      this.$set(this, 'tautans', []);
      this.onAddTautan();
    },

    getValue() {
      let form = { ...this.form };
      if (Object.keys(this.instruktur).length) {
        this.$set(
          form,
          this.jenis === 'kp_pa' ? 'psp_profil_id_pa' : 'instruktur_id',
          this.jenis === 'kp_pa'
            ? this.$getDeepObj(this.instruktur, 'id')
            : this.$getDeepObj(this, 'instruktur.akun_id') || this.$getDeepObj(this, 'instruktur.instruktur_id')
        );
      }

      this.$set(form, 'pendampingan_ke', this.id);
      return {
        id: this.id,
        form: Object.assign({}, form, { tautans: this.tatutans }),
      };
    },

    onPilihInstruktur() {
      const fields = [
        {
          key: 'nama',
          icon: 'mdi-account',
          title: '',
          list: [
            {
              keys: this.jenis === 'kp_pa' ? ['ptk.data.nama'] : ['nama'],
              class: 'body-1 blue--text',
            },
            {
              keys: this.jenis === 'kp_pa' ? ['ptk.data.email'] : ['email'],
              label: this.jenis === 'kp_pa' ? 'Akun SIMPKB: ' : 'Email: ',
              class: 'body-2 black--text',
            },
            {
              keys: ['akun_instansis.data.0.instansi.data.nama', 'psp_instrukturs.data.0.instansi.data.nama'],
              label: '',
              class: 'body-2 orange--text',
            },
            // {
            //   tipe: 'status',
            //   status: 'psp_instrukturs.data.0.instruktur_id',
            //   vTrue: 'Instruktur',
            //   vFalse: 'Narasumber',
            //   clrTrue: 'success',
            //   clrFalse: 'blue',
            // },
          ],
        },
      ];

      this.$refs.popup.open(fields).then((resp) => {
        this.instruktur = { ...(resp || {}) };
      });
    },

    onChangeBerkas(file) {
      this.$set(this.berkases, file.id, null);
      this.$set(this.form, file.name, null);
    },

    handleClickAppend(idFile) {
      this.$refs[`vFileInput_${idFile}`][0].$el.querySelector('input').click();
    },

    toLink(index) {
      const url = this.$getDeepObj(this.berkases, `${index}.url_berkas`);
      window.open(url, '_blank');
    },

    roundDecimal(value) {
      return roundDecimal(value);
    },

    onAddTautan() {
      if (this.tatutans.length === 20) {
        this.$error('Tautan tidak boleh lebih dari 20');
        return;
      }
      this.tatutans.push({ nama: '', url_meeting: '', url_recording: '' });
    },

    onDeleteTautan(index) {
      if (index === 0) return;
      this.tatutans.splice(index, 1);
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>
